import React, { useContext, useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { func } from 'prop-types'

// IMPORT COMPONENTS
import { Element, StyledLink, IconWrapper } from './'
import { ElementIcon } from '../HeaderBanner'
import { KebabMenu } from './KebabMenu'
import { Search as SearchIcon } from '../svgs/Search'
import { SiteConfigContext } from '../SiteConfigProvider'

const Elements = styled.ul`
	align-items: center;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	margin: 16px 0px;
	width: 100%;
`

/**
 * Navigation links layout for BDC
 *
 * @param {Function} props.handleSearchNavClick :: handles the search panel display
 * @param {Boolean} props.isOverlappingHero :: determines if the navigation links are overlapping the hero image
 *
 * TODO: this whole compoennt will be deprecated after the new header is rolled out
 */
export function NavigationLinksBdc({ handleSearchNavClick, isOverlappingHero = false }) {
	const {
		siteConstants: { HUB_LINKS },
	} = useContext(SiteConfigContext)

	const [displayedLinks, setDisplayedLinks] = useState()
	const [hiddenLinks, setHiddenLinks] = useState()
	const maxDesktopWidth = 1600
	const largeDesktopWidth = 1400
	const mediumDesktopWidth = 1200
	const smallDesktopWidth = 1000

	const maxDesktopLinks = 6
	const largeDesktopLinks = 5
	const mediumDesktopLinks = 4
	const smallDesktopLinks = 3

	useEffect(() => {
		const handleNavLinksDisplay = () => {
			const windowWidth = window.innerWidth
			const numOfLinks =
				windowWidth > maxDesktopWidth
					? maxDesktopLinks
					: window.innerWidth > largeDesktopWidth
					? largeDesktopLinks
					: window.innerWidth > mediumDesktopWidth
					? mediumDesktopLinks
					: window.innerWidth > smallDesktopWidth
					? smallDesktopLinks
					: 0

			setDisplayedLinks(HUB_LINKS.slice(0, numOfLinks))
			setHiddenLinks(HUB_LINKS.slice(numOfLinks, HUB_LINKS.length))
		}
		handleNavLinksDisplay()
		window.addEventListener('resize', handleNavLinksDisplay)

		return () => {
			window.removeEventListener('resize', handleNavLinksDisplay)
		}
	}, [HUB_LINKS])

	return (
		<Elements>
			{displayedLinks &&
				displayedLinks.map(({ isHighlighted = false, slug, title }, i) => {
					return (
						<Element key={i}>
							<StyledLink aria-label={title} href={`/${slug}/`} isHighlighted={isHighlighted}>
								{title}
							</StyledLink>
						</Element>
					)
				})}
			{hiddenLinks && hiddenLinks.length !== 0 && <KebabMenu menuItems={hiddenLinks} />}
			<ElementIcon onClick={handleSearchNavClick}>
				<IconWrapper>
					<SearchIcon />
				</IconWrapper>
			</ElementIcon>
		</Elements>
	)
}
NavigationLinksBdc.propTypes = {
	handleSearchNavClick: func,
}
